import React, { useState } from 'react';
import axios from 'axios';
import './RazorpayPayment.css'; // Import the CSS file

const RazorpayPayment = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    amount: '7198.50' // Default amount
  });
  
  const [loading, setLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState('');

  // Your AWS API Gateway Base URL
  const API_BASE_URL = 'https://qlw95zx5ta.execute-api.eu-north-1.amazonaws.com/t/payment';

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Add validation for amount field
    if (name === 'amount') {
      // Allow empty value while typing
      if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
        setFormData({
          ...formData,
          [name]: value
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const createPaymentOrder = async () => {
    try {
      setLoading(true);
      
      // Using the correct API endpoint: /create-order
      const response = await axios.post(`${API_BASE_URL}/create_order/create-order`, {
        email: formData.email,
        amount: formData.amount,
        fullName: formData.fullName,
        phoneNumber: formData.phoneNumber
      });

      if (response.data.status === 'success') {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to create order');
      }
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  };

  const verifyPayment = async (paymentData) => {
    try {
      // Using the correct API endpoint: /verify-payment
      const response = await axios.post(`${API_BASE_URL}/verify_payment/verify-payment`, {
        razorpay_order_id: paymentData.razorpay_order_id,
        razorpay_payment_id: paymentData.razorpay_payment_id,
        razorpay_signature: paymentData.razorpay_signature
      });

      return response.data;
    } catch (error) {
      console.error('Error verifying payment:', error);
      throw error;
    }
  };



  const handlePayment = async () => {
    try {
      // Validate form
      if (!formData.fullName || !formData.email || !formData.phoneNumber || !formData.amount) {
        alert('Please fill all required fields');
        return;
      }

      // Validate amount
      const amount = parseFloat(formData.amount);
      if (isNaN(amount) || amount < 1) {
        alert('Please enter a valid amount (minimum ₹1)');
        return;
      }

      // Create payment order
      const orderData = await createPaymentOrder();
      
      // Configure Razorpay options
      const options = {
        key: orderData.key,
        amount: orderData.amount,
        currency: orderData.currency,
        name: orderData.name,
        description: orderData.description,
        image: orderData.image,
        order_id: orderData.order_id,
        prefill: orderData.prefill,
        theme: orderData.theme,
        
        // Success handler
        handler: async function (response) {
          try {
            setPaymentStatus('Verifying payment...');
            
            // Verify payment on backend
            const verificationResult = await verifyPayment(response);
            
            if (verificationResult.status === 'success') {
              setPaymentStatus('Payment successful!');
              
              // Show success modal or redirect
              setTimeout(() => {
                alert(`Payment successful! Transaction ID: ${verificationResult.transaction_id}`);
                
                // Reset form
                setFormData({
                  fullName: '',
                  email: '',
                  phoneNumber: '',
                  amount: '7198.50'
                });
                setPaymentStatus('');
              }, 1000);
            } else {
              setPaymentStatus('Payment verification failed');
              alert('Payment verification failed. Please contact support.');
            }
          } catch (error) {
            setPaymentStatus('Payment verification failed');
            console.error('Verification error:', error);
            alert('Payment verification failed. Please contact support.');
          } finally {
            setLoading(false);
          }
        },
        
        // Failure handler
        modal: {
          ondismiss: function () {
            setPaymentStatus('Payment cancelled by user');
            setLoading(false);
          }
        }
      };

      // Open Razorpay checkout
      const rzp = new window.Razorpay(options);
      
      rzp.on('payment.failed', function (response) {
        setPaymentStatus('Payment failed');
        setLoading(false);
        alert(`Payment failed: ${response.error.description}`);
      });

      rzp.open();
      
    } catch (error) {
      setPaymentStatus('Error initiating payment');
      setLoading(false);
      console.error('Payment error:', error);
      alert('Error initiating payment. Please try again.');
    }
  };

  return (
    <div className="razorpay-payment-container">
      <div className="razorpay-payment-card">
        <div className="payment-header">
          <h1 className="payment-title">Instant Payment Gateway</h1>
          <p className="payment-subtitle">Gen AI Data Science Internship</p>
        </div>
        
        <form className="payment-form" onSubmit={(e) => e.preventDefault()}>
          <div className="form-group">
            <label className="form-label">
              Full Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              Email Address <span className="required">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="form-input"
              placeholder="your.email@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              Phone Number <span className="required">*</span>
            </label>
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              className="form-input"
              placeholder="+91 XXXXX XXXXX"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              Course Fee <span className="required">*</span>
            </label>
            <div className="amount-input-container">
              <span className="currency-symbol">₹</span>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleInputChange}
                className="form-input amount-input"
                step="0.01"
                min="1"
                placeholder="Enter amount"
                required
              />
            </div>
            <small className="form-note">Enter the course fee amount (minimum ₹1)</small>
          </div>

          <button
            type="button"
            onClick={handlePayment}
            disabled={loading}
            className={`payment-button ${loading ? 'loading' : ''}`}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Processing...
              </>
            ) : (
              <>
                <span className="payment-icon">⚡</span>
                Pay ₹{formData.amount} Instantly
              </>
            )}
          </button>
        </form>

        {paymentStatus && (
          <div className={`status-alert ${
            paymentStatus.includes('successful') ? 'success' : 
            paymentStatus.includes('failed') || paymentStatus.includes('Error') ? 'error' : 'info'
          }`}>
            <div className="status-icon">
              {paymentStatus.includes('successful') ? '✅' : 
               paymentStatus.includes('failed') ? '❌' : 'ℹ️'}
            </div>
            <span className="status-text">{paymentStatus}</span>
          </div>
        )}

        <div className="payment-features">
          <div className="feature-item">
            <span className="feature-icon">🔒</span>
            <span>256-bit SSL encryption</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">📧</span>
            <span>Instant receipt via email</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🏛️</span>
            <span>RBI approved gateway</span>
          </div>
        </div>

        <div className="supported-methods">
          <p className="methods-title">Supported Payment Methods:</p>
          <div className="methods-grid">
            <div className="method-item">💳 Credit/Debit Cards</div>
            <div className="method-item">📱 UPI (GPay, PhonePe, Paytm)</div>
            <div className="method-item">🏦 Net Banking</div>
            <div className="method-item">💰 Digital Wallets</div>
          </div>
        </div>

        <div className="alternative-option">
          <p>Prefer manual payment methods?</p>
          <a href="/payment" className="manual-payment-link">
            Use Manual Payment Options →
          </a>
        </div>
      </div>
    </div>
  );
};

export default RazorpayPayment;